/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RiskCategoryWrite
 */
export interface RiskCategoryWrite {
  /**
   *
   * @type {string}
   * @memberof RiskCategoryWrite
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof RiskCategoryWrite
   */
  title: string;
  /**
   *
   * @type {number}
   * @memberof RiskCategoryWrite
   */
  parent?: number | null;
  /**
   *
   * @type {string}
   * @memberof RiskCategoryWrite
   */
  description?: string | null;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof RiskCategoryWrite
   */
  children?: Array<{ [key: string]: any }>;
}

/**
 * Check if a given object implements the RiskCategoryWrite interface.
 */
export function instanceOfRiskCategoryWrite(value: object): value is RiskCategoryWrite {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('title' in value) || value['title'] === undefined) return false;
  return true;
}

export function RiskCategoryWriteFromJSON(json: any): RiskCategoryWrite {
  return RiskCategoryWriteFromJSONTyped(json, false);
}

export function RiskCategoryWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): RiskCategoryWrite {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    title: json['title'],
    parent: json['parent'] == null ? undefined : json['parent'],
    description: json['description'] == null ? undefined : json['description'],
    children: json['children'] == null ? undefined : json['children'],
  };
}

export function RiskCategoryWriteToJSON(value?: RiskCategoryWrite | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    title: value['title'],
    parent: value['parent'],
    description: value['description'],
    children: value['children'],
  };
}
